import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'

import StyledTable from '@components/StyledTable'
import type { SearchResults } from '@models/SearchResults'

import type { HoofdnetOpdracht } from '../../../opdracht/hoofdnet/types/HoofdnetOpdracht'
import { HoofdnetOpdrachtenTableRow } from '../../../opdrachten/hoofdnet/components/HoofdnetOpdrachtenTableRow'
import { PageSection } from '../../../theme/components/PageSection'

const headerCells = [
  { id: 'opdrachtId', numeric: true, label: 'Opdracht id', sort: false },
  { id: 'versieNummer', label: 'Versienummer', sort: false, fixed: 50 },
  { id: 'details.discipline', label: 'Discipline', sort: false, fixed: 50 },
  { id: 'opdrachtgever', numeric: true, label: 'Opdrachtgever', sort: false },
  { id: 'opdrachtnemer', numeric: true, label: 'Opdrachtnemer', sort: false },
  {
    id: 'created',
    numeric: false,
    label: 'Creatiedatum',
    sort: true,
  },
  { id: 'changed', numeric: false, label: 'Mutatiedatum', sort: true },
  { id: 'status', label: 'Status', sort: false },
  { id: 'details', label: 'Details', sort: false, fixed: 100 },
] as const

interface Props {
  opdrachten: SearchResults<HoofdnetOpdracht>
  onChangePage: any
  isLoading: boolean
}

export const HoofdnetOpdrachten = ({
  opdrachten,
  onChangePage,
  isLoading,
}: Props) => {
  const { items, count, skip, limit } = opdrachten

  return (
    <PageSection heading="Opdrachten" id="opdrachten">
      <Box>
        <Accordion defaultExpanded>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography>Alle hoofdnet opdrachten</Typography>
          </AccordionSummary>

          <AccordionDetails sx={{ padding: 0 }}>
            <StyledTable
              variant="details"
              onChangePage={onChangePage}
              headerCells={headerCells}
              stats={{ count, skip, limit }}
              loading={isLoading}
              sort={{}}
              {...({} as any)}
            >
              {items.map((opdracht) => {
                return (
                  <HoofdnetOpdrachtenTableRow
                    key={opdracht.opdrachtId}
                    opdracht={opdracht}
                  />
                )
              })}
            </StyledTable>
          </AccordionDetails>
        </Accordion>
      </Box>
    </PageSection>
  )
}
